import { render } from "./ChooseProperties.vue?vue&type=template&id=69fbbb58"
import script from "./ChooseProperties.vue?vue&type=script&lang=js"
export * from "./ChooseProperties.vue?vue&type=script&lang=js"

import "./ChooseProperties.vue?vue&type=style&index=0&id=69fbbb58&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__